import React, { useEffect, useState } from "react";
import "./UserRegistration.css";
// import RegistrationTopImage from "../../assets/images/RegistrationTopImage.png";
import { getattachmentname, getdefaulttaglist, uploadcustomerattachments, upsertcustomer } from "../../redux/services/authService";
import { encrypt } from "../../redux/services/encryptionUtils";
import banner1 from "../../assets/images/banner1.png"
import { AllowedExtensions } from "../../config";


const StepLabel = ({ children, active }) => (
  <div className={`step ${active ? "active" : ""}`}>
    <div className="step-label">{children}</div>
  </div>
);

export default function UserRegistration({ onBackToLogin }) {

 

  const [step, setStep] = useState(1);
  const [account, setAccount] = useState([]);
  const [imgType, setImgType] = useState([]);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    country: 1,
    accountType: 0,
    tradeLicense: null,
    vatCertificate: null,
    attachments: []
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState({
  password: false,
  confirmPassword: false
});

const togglePasswordVisibility = (field) => {
  setShowPassword(prev => ({
    ...prev,
    [field]: !prev[field]
  }));
};

  const onChange = (e) => {
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));
    if (errors[e.target.name]) {
      setErrors(prev => ({ ...prev, [e.target.name]: '' }));
    }
  };

  const onFileChange = (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

   const ext = file.name.split(".").pop().toLowerCase();
   if (!AllowedExtensions.includes(ext)) {

  // Remove existing attachment of this same attachType (field.Id)
  setForm((prev) => {
    const updatedAttachments = (prev.attachments || []).filter(
      (a) => a.attachType !== field?.Id
    );

    return {
      ...prev,
      [field?.Name]: null,      // clear field value
      attachments: updatedAttachments, // remove old attachment
    };
  });

  setErrors((prev) => ({
    ...prev,
    [field?.Name]:  `Allowed file types are: ${AllowedExtensions.split(",").join(", ")}.`,
  }));

  e.target.value = ""; // reset input UI
  return;
}

    setForm((prev) => {
  const existing = prev.attachments || [];

  // Check if this attachType already exists
  const index = existing.findIndex(a => a.attachType === field?.Id);

  let updatedAttachments;

  if (index !== -1) {
    // Replace existing entry
    updatedAttachments = [...existing];
    updatedAttachments[index] = {
      ...updatedAttachments[index],
      fileName: file.name,
      file: file
    };
  } else {
    // Add new entry
    const slNo = existing.length + 1; 
    updatedAttachments = [
      ...existing,
      {
        fileName: file.name,
        refNo: slNo,
        slNo: slNo,
        attachType: field?.Id,
        file: file
      }
    ];
  }

  return {
    ...prev,
    attachments: updatedAttachments,
    [field?.Name]: file,
  };
});


    // Clear field-specific error if present
    if (errors[field?.Name]) {
      setErrors((prev) => ({ ...prev, [field?.Name]: '' }));
    }
  };

  useEffect(() => {

    const fetchData = async () => {
      const params = {
        tagId: 9,
        languageId: 1,
        bE: 1,
        type: 1
      }
      const response = await getdefaulttaglist(params);
  
      
      const results = JSON.parse(response?.result) || [];
      setAccount(results)
    }
    fetchData();
  }, [])

  useEffect(() => {

    const fetchData = async () => {
      const params = {
        AccountType: form?.accountType,

      }
      const response = await getattachmentname(params);
      const results = JSON.parse(response?.result) || [];
      setImgType(results)
    }
    if (form?.accountType > 0) {
      fetchData();
    }else{
      setImgType([])
    }
   // Clear previous file fields + attachments
  setForm((prev) => {
    const cleanedForm = { ...prev, attachments: [] };

    // Remove old dynamic file fields
    imgType?.forEach((item) => {
      if (item?.Name) cleanedForm[item.Name] = null;
    });

    return cleanedForm;
  });

  }, [form?.accountType])




  const validateStep1 = () => {
  
    const newErrors = {};
    if (!form.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!form.lastName.trim()) newErrors.lastName = 'Last name is required';
    return newErrors;
  };

  const validateStep2 = () => {
    const newErrors = {};
    if (!form.email.trim()) newErrors.email = 'Email is required';
    else if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(form.email)) newErrors.email = 'Email is invalid';

    if (!form.username.trim()) newErrors.username = 'Username is required';

    if (!form.mobile.trim()) newErrors.mobile = 'Mobile number is required';
    else if (!/^[0-9]{10,15}$/.test(form.mobile)) newErrors.mobile = 'Mobile number is invalid';

    if (!form.password) {
      newErrors.password = 'Password is required';
    } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/.test(form.password)) {
      newErrors.password = 'Password must be at least 6 characters long and include at least one letter, one number, and one special character.';
    }


    if (!form.confirmPassword) newErrors.confirmPassword = 'Please confirm password';
    else if (form.password !== form.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';

    return newErrors;
  };

  const validateStep3 = () => {

  const newErrors = {};

  // Validate required base fields
  if (!form.country) newErrors.country = 'Country is required';
  if (!form.accountType) newErrors.accountType = 'Account type is required';

  // Safely validate image fields
  if (Array.isArray(imgType)) {
    imgType.forEach((item) => {
      if (item?.Name && !form[item.Name]) {
        newErrors[item.Name] = `${item.Name} is required`;
      }
    });
  }

  return newErrors;
};


  const next = () => {
    let newErrors = {};


    switch (step) {
      case 1:
        newErrors = validateStep1();
        break;
      case 2:
        newErrors = validateStep2();
        break;
      case 3:
        newErrors = validateStep3();
        break;
      default:
        break;
    }

    if (Object.keys(newErrors).length === 0) {
      setStep((s) => Math.min(3, s + 1));
      setErrors({});
    } else {
      setErrors(newErrors);
    }
  };

  const prev = () => {
    setStep((s) => Math.max(1, s - 1));
    setErrors({});
  };


  const isStepValid = (stepNumber) => {
    
  
    switch (stepNumber) {
      case 1:
        return form.firstName.trim() && form.lastName.trim();
      case 2:
        return form.email.trim() &&
          form.username.trim() &&
          form.mobile.trim() &&
          form.password &&
          form.confirmPassword &&
          form.password === form.confirmPassword;
      case 3:
        return form.country && form.accountType && form?.attachments.length ==imgType?.length;
      default:
        return false;
    }
  };

  const handleSubmit = async () => {

    if(!isStepValid(step)){
        next();
        return
    } 
  
    const encryptedPassword = await encrypt(form?.password)
    try {
      const saveData = {
        id: 0,
        firstName: form?.firstName,
        lastName: form?.lastName,
        email: form?.email,
        userName: form?.username,
        mobile: form?.mobile,
        password: encryptedPassword,
        country: form?.country,
        accountType: form?.accountType,
        be: 1,
        attachments: form?.attachments || []
      };

      const response = await upsertcustomer(saveData);

      if (response?.status === "Success") {
        const detailId = Number(response.result);

        // Only process attachments that include a file
        const attachmentsWithFile = (form?.attachments || []).filter(
          (attachment) => attachment.file
        );

        if (detailId && attachmentsWithFile.length > 0) {
          const formData = new FormData();

          // Required parameters
          formData.append("TransId", detailId.toString());
          formData.append("docType", "0");
          formData.append("bE", "1");

          // Append attachments dynamically
          attachmentsWithFile.forEach((attachment, index) => {
            formData.append(`attachmentsRequest[${index}].fileContent`, attachment.file);
            formData.append(`attachmentsRequest[${index}].previousFileName`, attachment.fileName || "");
            formData.append(`attachmentsRequest[${index}].SlNo`, attachment.slNo?.toString() || "0");
            formData.append(`attachmentsRequest[${index}].transDtId`, attachment.refNo?.toString() || "0");
            formData.append(`attachmentsRequest[${index}].type`, attachment.attachType?.toString() || "0");
          });

          try {
            await uploadcustomerattachments(formData);
          } catch (uploadError) {
            console.error("Attachment upload failed:", uploadError);
          }
        }

        // Navigate back after success
        onBackToLogin();
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };


const style = {
    backgroundImage: banner1 ? `url(${banner1})` : undefined,
    "--banner-height": "110px",
  };

  return (
    <div className="urp-page">
      <div className="urp-hero" style={style}>
        <div className="urp-hero-inner">
          <h1 style={{ fontSize: "20px" }}>User Registration</h1>

        </div>
      </div>

      <div className="urp-container">
        <div className="urp-stepper" aria-hidden>
          <StepLabel active={step === 1}>General details</StepLabel>
          <StepLabel active={step === 2}>User Details</StepLabel>
          <StepLabel active={step === 3}>Upload Docs</StepLabel>
        </div>

        <form className="urp-form" onSubmit={(e) => e.preventDefault()}>
          {step === 1 && (
            <section className="form-block">
              <label className="field-label">
                Name <span className="required">*</span>
              </label>
              <input
                name="firstName"
                value={form.firstName}
                onChange={onChange}
                className={`text-input ${errors.firstName ? 'error' : ''}`}
                placeholder="First Name*"
                maxLength={60}
              />
              {errors.firstName && <span className="error-message">{errors.firstName}</span>}

              <input
                name="lastName"
                value={form.lastName}
                onChange={onChange}
                className={`text-input ${errors.lastName ? 'error' : ''}`}
                placeholder="Last Name*"
                maxLength={60}
              />
              {errors.lastName && <span className="error-message">{errors.lastName}</span>}
            </section>
          )}

          {step === 2 && (
            <section className="form-block">
              <label className="field-label">
                Email <span className="required">*</span>
              </label>
              <input
                name="email"
                value={form.email}
                onChange={onChange}
                className={`text-input ${errors.email ? 'error' : ''}`}
                placeholder="Email*"
                type="email"
                maxLength={60}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}

              <label className="field-label">
                Username <span className="required">*</span>
              </label>
              <input
                name="username"
                value={form.username}
                onChange={onChange}
                className={`text-input ${errors.username ? 'error' : ''}`}
                placeholder="Username*"
                maxLength={60}
              />
              {errors.username && <span className="error-message">{errors.username}</span>}

              <label className="field-label">
                Mobile Number <span className="required">*</span>
              </label>
              <input
                name="mobile"
                value={form.mobile}
                onChange={onChange}
                className={`text-input ${errors.mobile ? 'error' : ''}`}
                placeholder="Mobile Number*"
                autoComplete="off"
                maxLength={15}
              />
              {errors.mobile && <span className="error-message">{errors.mobile}</span>}

               <div className="two-col">
  <div >
    <label className="field-label">
      Password <span className="required">*</span>
    </label>
    <div className="reg-password-input-container">
      <input
        type={showPassword.password ? "text" : "password"}
        name="password"
        value={form.password}
        onChange={onChange}
        className={`password-swal-input ${errors.password ? 'error' : ''}`}
        placeholder="New Password*"
        maxLength={30}
        autoComplete="new-password"
      />
      <span 
        className="password-eye-icon" 
        onClick={() => togglePasswordVisibility('password')}
        style={{cursor: 'pointer'}}
      >
        {showPassword.password ? (
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
          </svg>
        )}
      </span>
    </div>
    {errors.password && <span className="error-message">{errors.password}</span>}
  </div>
  <div>
    <label className="field-label">
      Confirm Password <span className="required">*</span>
    </label>
    <div className="reg-password-input-container">
      <input
        type={showPassword.confirmPassword ? "text" : "password"}
        name="confirmPassword"
        value={form.confirmPassword}
        onChange={onChange}
        className={`password-swal-input ${errors.confirmPassword ? 'error' : ''}`}
        placeholder="Confirm Password*"
        maxLength={30}
      />
      <span 
        className="password-eye-icon" 
        onClick={() => togglePasswordVisibility('confirmPassword')}
        style={{cursor: 'pointer'}}
      >
        {showPassword.confirmPassword ? (
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
          </svg>
        )}
      </span>
    </div>
    {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
  </div>
</div>
            </section>
          )}

          {step === 3 && (
            <section className="form-block">
              <label className="field-label">
                Country <span className="required">*</span>
              </label>
              <select
                name="country"
                value={form.country}
                onChange={onChange}
                className={`select-input ${errors.country ? 'error' : ''}`}
              >
                <option value={1}>UAE</option>
              </select>
              {errors.country && <span className="error-message">{errors.country}</span>}

              <label className="field-label">
                Account Type <span className="required">*</span>
              </label>
              <select
                name="accountType"
                value={form.accountType}
                onChange={onChange}
                className={`select-input blue-outline ${errors.accountType ? 'error' : ''}`}
              >
                <option value={0}>Select an option</option>
                {account?.map((item) => (
                  <option value={item?.Id}>{item?.Name}</option>
                ))}

              </select>
              {errors.accountType && <span className="error-message">{errors.accountType}</span>}

              {imgType?.map((item) => (
                <>

                  <label className="field-label">
                    {item?.Name} <span className="required">*</span>
                  </label>
                  <div className={`dropzone ${errors[item?.Name] ? 'error' : ''}`}>
                    <div className="dz-icon">📁</div>
                    <div className="dz-text">
                      {form[item?.Name] ? form[item?.Name].name : "Click or drag a file to this area to upload."}
                    </div>
                    <input
                      type="file"
                      className="dz-input"
                      onChange={(e) => onFileChange(e,item)}
                    />
                  </div>
                  {errors[item?.Name] && <span className="error-message">{errors[item?.Name]}</span>}
                </>
              ))}
              
            </section>
          )}

          <div className="form-actions">
            {step > 1 && (
              <button type="button" className="btn btn-ghost" onClick={prev}>
                Previous
              </button>
            )}

            {step < 3 ? (
              <button
                type="button"
                className={`btn btn-primary ${!isStepValid(step) ? 'btn-disabled' : ''}`}
                onClick={next}
                //disabled={!isStepValid(step)}
              >
                Next
              </button>
            ) : (
              <button
                type="submit"
                className={`btn btn-primary ${!isStepValid(step) ? 'btn-disabled' : ''}`}
               // disabled={!isStepValid(step)}
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}

            <button type="button" className="btn btn-outline" onClick={onBackToLogin}>
              Back to login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}